import styled from "styled-components";

/**
 * Wrapper do Checkbox
 * Configura layout flexível e alinhamento da label e do checkbox.
 */
export const StyledCheckboxWrapper = styled.div.withConfig({
  shouldForwardProp: (prop) => !["isMobile"].includes(prop as string),
})<{ isMobile: boolean }>`
  gap: ${({ isMobile, theme }) => !isMobile && theme.spacing(1.5)};
  align-items: center;
  cursor: pointer;
  display: flex;
  max-width: fit-content; /* Garante que o wrapper não expanda */
`;

/**
 * Estilo do Checkbox
 * Configura estilização dinâmica, incluindo estados marcados e desmarcados.
 */
export const StyledCheckbox = styled.input`
  appearance: none;
  display: inline-block;
  width: 20px;
  height: 20px;
  min-width: 20px;
  min-height: 20px;
  max-width: 20px;
  max-height: 20px;

  border-radius: ${({ theme }) => theme.borderRadius.medium};
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  background-color: ${({ theme }) => theme.colors.white};
  margin-right: ${({ theme }) => theme.spacing(1)};
  position: relative;
  cursor: pointer;

  &:checked {
    background-color: ${({ theme }) => theme.colors.vividBlue};
    border-color: ${({ theme }) => theme.colors.vividBlue};
  }

  &:checked::before {
    content: "✔";
    position: absolute;
    font-size: 14px;
    color: ${({ theme }) => theme.colors.white};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
